import { Environment } from '@abp/ng.core';

const baseUrl = 'https://app.tomstoolbox.honeydoservice.com';

const oAuthConfig = {
  issuer: 'https://auth.tomstoolbox.honeydoservice.com/',
  redirectUri: baseUrl,
  clientId: 'TTB_App',
  responseType: 'code',
  scope: 'offline_access TTB',
  requireHttps: true,
};

export const environment = {
  production: true,
  application: {
    baseUrl,
    name: 'TTB',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://api.tomstoolbox.honeydoservice.com',
      rootNamespace: 'TTB',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
    Calendar: {
      url: "https://calendar.tomstoolbox.honeydoservice.com"
    }
  },
  remoteEnv: {
    url: '/getEnvConfig',
    mergeStrategy: 'deepmerge'
  },
  mapsToken: 'AIzaSyCQW6nRoG-ZHRj-d29Jf7R2drvFFoFOstQ'
} as Environment;
